var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletWc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8559 46.4858C25.2959 46.7482 20.5078 43.3438 16.8168 39.3019C12.8104 34.9145 9.07798 29.6282 10.2033 23.8697C11.3653 17.9232 16.4437 13.2946 22.3048 11.2185C27.5674 9.35446 33.1003 11.4128 38.0172 14.0178C42.5415 16.4149 46.6817 19.8098 47.7528 24.7012C48.8074 29.5172 46.332 34.1187 43.2804 38.053C40.0832 42.1751 36.1676 46.2351 30.8559 46.4858Z",
    fill: "#FFD550"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3913_34151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 17.5C10.9375 15.2687 12.6437 13.5625 14.875 13.5625H37.8438C38.8938 13.5625 39.8125 14.4812 39.8125 15.5312C39.8125 16.5813 38.8938 17.5 37.8438 17.5H16.1875",
    stroke: "#191414",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9375 31.9375C31.9375 29.05 34.3 26.6875 37.1875 26.6875H42.4375C43.8813 26.6875 45.0625 25.5063 45.0625 24.0625C45.0625 22.6187 43.8813 21.4375 42.4375 21.4375H14.875C12.6437 21.4375 10.9375 19.6 10.9375 17.5V38.5C10.9375 40.6 12.6437 42.4375 14.875 42.4375H42.4375C43.8813 42.4375 45.0625 41.2563 45.0625 39.8125C45.0625 38.3687 43.8813 37.1875 42.4375 37.1875H37.1875C34.3 37.1875 31.9375 34.825 31.9375 31.9375Z",
    stroke: "#191414",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1875 31.9375H39.8125",
    stroke: "#191414",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0625 24.0625V39.8125",
    stroke: "#191414",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3913_34151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWc);
export default __webpack_public_path__ + "static/media/wallet_wc.95c2040df463bdae9586c2eae66a10f0.svg";
export { ForwardRef as ReactComponent };